/**
 * Attention1: structure
 * div.class=container-filter.dataEventId="uniID"
 *  div.class="container-wrapper"
 *    div.class="catalog"
 *    div.class="dropdown"
 *      div.class="select".dataEventId="uniID"
 *      button.class="filter".dataEventId="uniID"
 *
 * Attention2: each select checkbox must have the uniId, attend it to the label for
 */

import "./index.css";
import { IContext } from "@src/context";
import filterState, { IUpdate } from "./filterState";
import { classNameSplice, findChild, findParent } from "@src/utils/dom";
import fetchCardsHelper from "../SearchCards/fetchCardsHelper";
import { FILTER_ID_PLP_BOTTOM, FILTER_ID_PLP_TOP } from "@src/utils/constant";
import { anaFilterOption } from "./analytic";
interface IFilterChangeData extends DOMStringMap {
  event?: EEventType; // event name
  eventId?: string; // the id of the filter
  eventPayload?: string; // additional information of the event such as type,size,rent
}
interface IFilterParams {
  "room-type": string[];
  "room-size": string[];
  "room-rent": string[];
  "room-option": string[];
}

enum EEventType {
  selectAll = "select-all",
  selectItem = "select-checkbox",
  selectShow = "select-show",
  filter = "filter",
}

const FILTER_CONTAINER = "container-filter";
const spliceName = classNameSplice(FILTER_CONTAINER);
// select parent class
const SELECT = spliceName("select");
// show select list class
const SELECT_ON = spliceName("select__on");
const SELECT_LIST = spliceName("select-list");
// active select if selected
const SELECT_ACTIVE = spliceName("select__active");

function toggleSelectAll(
  target: HTMLElement,
  selectData: Required<IFilterChangeData>
) {
  const filterItems = findParent(target.parentElement, SELECT_LIST);
  if (!filterItems) return;
  const eventId = selectData.eventId;
  const type = selectData.eventPayload;
  const length = Number(filterItems?.children.length);
  const newChecked = !(
    Number(filterState.getArgs(eventId, type).size) >=
    // length contain the label selectAll,need - 1
    length - 1
  );
  anaFilterOption({ id: "all", type, checked: newChecked, value: "全て" });

  // start from 1 to deprecate the child of selectAll
  for (let i = 1; i < length; i++) {
    const liElement = filterItems.children.item(i);
    const checkboxEle = findChild(
      liElement,
      spliceName("select-item-checkbox")
    ) as HTMLInputElement;
    if (checkboxEle && checkboxEle.checked !== newChecked) {
      checkboxEle.checked = newChecked;
      const updateParam = {
        id: eventId,
        type,
        checked: newChecked,
        value: checkboxEle.value,
      };

      updateCheckbox(updateParam, checkboxEle);
    }
  }
}

function toggleSelect(target: HTMLElement) {
  const filterComponent = findParent(
    target.parentElement,
    SELECT
  ) as HTMLUListElement;
  if (!filterComponent) return;

  if (
    filterState.getShowListElement() &&
    filterComponent !== filterState.getShowListElement()
  ) {
    filterState.getShowListElement()?.classList.remove(SELECT_ON);
  }

  if (filterComponent?.classList.contains(SELECT_ON)) {
    filterState.updateShowListElement(null);
    filterComponent.classList.remove(SELECT_ON);
  } else {
    filterState.updateShowListElement(filterComponent);
    filterComponent?.classList.add(SELECT_ON);
  }
}

//active selected filter
function toggleActiveSelect({
  target,
  id,
  type,
}: {
  target: HTMLElement | null;
  id: string;
  type: string;
}) {
  if (!target) return;
  const selectWrap = findParent(target, SELECT);
  if (!selectWrap) return;
  const args = filterState.getArgs(id, type) as Set<string>;
  if (args.size > 0 && !selectWrap?.classList.contains(SELECT_ACTIVE)) {
    selectWrap?.classList.add(SELECT_ACTIVE);
    return;
  }
  if (args.size <= 0 && selectWrap?.classList.contains(SELECT_ACTIVE)) {
    selectWrap?.classList.remove(SELECT_ACTIVE);
    return;
  }
}

function search(target: HTMLElement) {
  const data = target.dataset as Required<IFilterChangeData>;
  if (data.eventId === FILTER_ID_PLP_BOTTOM) {
    // HACK SEARCH
    // the bottom search in PLP
    const ele = document.querySelector(".container-filter");
    if (ele) {
      ele.scrollIntoView();
    }
  }
  fetchCardsHelper.clearRequest();
  fetchCardsHelper.loadMore(filterState.getApiFilterAndSort(data.eventId));
}

function findSelectDataFromTarget(target: HTMLElement) {
  const selectParent = findParent(target.parentElement, SELECT);
  return selectParent?.dataset as Required<IFilterChangeData>;
}

function pureUpdateCheckbox(param: IUpdate, target: HTMLElement | null) {
  filterState.updateArg(param);
  toggleActiveSelect({
    id: param.id,
    type: param.type,
    target,
  });
}

function updateCheckbox(param: IUpdate, target: HTMLInputElement | null) {
  if (!target) return;
  if (param.id === FILTER_ID_PLP_BOTTOM || param.id === FILTER_ID_PLP_TOP) {
    const inputType = target.id.split("-").at(-1);
    const bottomInput = document.querySelector<HTMLInputElement>(
      `#${FILTER_ID_PLP_BOTTOM}-${inputType}`
    );
    const topInput = document.querySelector<HTMLInputElement>(
      `#${FILTER_ID_PLP_TOP}-${inputType}`
    );
    if (!topInput || !bottomInput) return;
    pureUpdateCheckbox({ ...param, id: FILTER_ID_PLP_BOTTOM }, bottomInput);
    pureUpdateCheckbox({ ...param, id: FILTER_ID_PLP_TOP }, topInput);
    bottomInput.checked = target.checked;
    topInput.checked = target.checked;
    return;
  }
  pureUpdateCheckbox(param, target);
}

export function getFilterParamsByUrl(): IFilterParams {
  // example: `?elevator=1&parking=1&pet=1&available=1&room_type=1K&room_size=2&room_rent=2,3`
  const urlParams = new URLSearchParams(window.location.search);
  return {
    "room-type":
      urlParams
        .get("room_type")
        ?.split(",")
        .map((item) => item.toUpperCase()) || [],
    "room-size": urlParams.get("room_size")?.split(",") || [],
    "room-rent": urlParams.get("room_rent")?.split(",") || [],
    "room-option": ["elevator", "parking", "pet", "available"]
      .map((key, index) => (urlParams.get(key) === "1" ? index.toString() : ""))
      .filter((item) => item),
  };
}

export function hasFilterUrlParams(filterParams: IFilterParams): boolean {
  return Object.values(filterParams).some((item) => item.length > 0);
}

export function hasOnlyOptionFilterUrlParams(
  filterParams: IFilterParams
): boolean {
  return (
    filterParams["room-type"].length === 0 &&
    filterParams["room-size"].length === 0 &&
    filterParams["room-rent"].length === 0 &&
    filterParams["room-option"].length > 0
  );
}

// eslint-disable-next-line
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function setupFilter(context: IContext) {
  // click event handler
  document.querySelectorAll(`.${FILTER_CONTAINER}`)?.forEach((selectEle) => {
    selectEle.addEventListener(
      "click",
      function (this: HTMLSelectElement, e: Event) {
        const sourceEle = e.target as HTMLElement;
        const dataSet = sourceEle.dataset as IFilterChangeData;

        if (!dataSet.event) return;
        switch (dataSet.event) {
          case EEventType.selectAll:
            toggleSelectAll(sourceEle, findSelectDataFromTarget(sourceEle));
            break;
          case EEventType.selectShow:
            toggleSelect(sourceEle);
            break;
          case EEventType.filter:
            search(sourceEle);
            break;
        }
      }
    );
  });

  // update select items by url params
  const filterParams = getFilterParamsByUrl();
  if (hasFilterUrlParams(filterParams)) {
    Object.entries(filterParams).forEach(([key, data]) => {
      document
        .querySelectorAll(
          `.container-filter-select[data-event-payload="${key}"]`
        )
        .forEach((element) => {
          data.forEach((value: string) => {
            const checkboxEle = element.querySelector<HTMLInputElement>(
              `input[data-event="select-checkbox"][value="${value}"]`
            );
            if (!checkboxEle) return;
            checkboxEle.checked = true;
            const data = findSelectDataFromTarget(checkboxEle);
            const updateItem: IUpdate = {
              id: data.eventId,
              type: data.eventPayload,
              checked: checkboxEle.checked,
              value: checkboxEle.value,
            };
            updateCheckbox(updateItem, checkboxEle);
          });
        });
    });
    // only trigger search if the filter is in PLP top, and not only option filter.
    if (!hasOnlyOptionFilterUrlParams(filterParams)) {
      const searchBtn: HTMLElement | null = document.querySelector(
        ".container-filter-filter-search[data-event-id='filter-plp-top'][data-event='filter']"
      );
      if (searchBtn) {
        search(searchBtn);
      }
    }
  }

  // change select items
  //@TODO move the event to click event handler
  document
    .querySelectorAll("input[data-event='select-checkbox']")
    ?.forEach((selectEle) => {
      selectEle.addEventListener("change", function (this: HTMLInputElement) {
        const data = findSelectDataFromTarget(this);
        const id = data.eventId;
        const updateItem: IUpdate = {
          id,
          type: data.eventPayload,
          checked: this.checked,
          value: this.value,
        };
        updateCheckbox(updateItem, this);
        anaFilterOption(updateItem);
      });
    });

  // hide select list if click outside of the list
  document.addEventListener("click", function (e) {
    const showListElement = filterState.getShowListElement();
    if (showListElement && !findParent(e.target as HTMLElement, SELECT)) {
      showListElement.classList.remove(SELECT_ON);
      filterState.updateShowListElement(null);
    }
  });
}
